export const DEALER_FIVE_STAR_LOGO = '/img/dealer-thanks/5star-dealer-bottom.png';
export const NO_VEHICLE_GRAY_IMAGE_SUV = '/img/e17/no-vehicle-gray-images/no-vehicle-gray-image-suv.svg';
export const NO_VEHICLE_GRAY_IMAGE_TRUCK = '/img/e17/no-vehicle-gray-images/no-vehicle-gray-image-truck.svg';
export const NO_VEHICLE_GRAY_IMAGE_SEDAN = '/img/e17/no-vehicle-gray-images/no-vehicle-gray-image-sedan.svg';
export const NO_VEHICLE_BLUE_EDMUNDS_LOGO = 'dam:///photo/non-make/ot/ot_801223';
